import { LocaleEnums } from "models/enums";
import { useSelector } from "react-redux";
import { AppState } from "store";

function useFAQArticleLink() {
  const language = useSelector((store: AppState) => store.common.locale.language);

  const getUrl = (url: string) => {
    return language === LocaleEnums.LocaleType.sv ? url : `https://translate.google.com/translate?sl=sv&tl=en&u=${url}`;
  };

  return { getFAQUrl: getUrl };
}

export default useFAQArticleLink;
